import React from 'react'
import { Box, Typography } from '@mui/material'
import _sxs from './_sxs'
import { MessageStateProps } from './_props'

const MessageState: React.FC<MessageStateProps> = ({ text, image, error = false }) => (
    <Box sx={_sxs.MessageStateContent}>
        {image}
        <Typography sx={error ? _sxs.ErrorStateText : _sxs.MessageStateText}>{text}</Typography>
    </Box>
)

export default MessageState
